import { useMutation, useQueryClient } from "react-query";

import { crearCentrosCompostaje, updateCentrosCompostaje, deleteCentrosCompostaje} from '../../services/CentrosCompostaje';

import { toast } from 'react-hot-toast';
const queryKey = "centrosCompostaje";

export const useCentrosMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addCentro = useMutation((body) => crearCentrosCompostaje(body), {
    onSuccess,
    onError: (err) => onError(err),
  });
  const updateCentroD = useMutation(
    (body) => updateCentrosCompostaje( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removeCentro = useMutation((id) => deleteCentrosCompostaje( id), {
    onSuccess,
    onError,
  });

  return { addCentro, updateCentroD, removeCentro };
};
export default useCentrosMutations;